Vue.filter("humantime", function (value) {
    var varValue = moment(value).fromNow();
    if (varValue === "a day ago") {
        return "1 day ago";
    }
    else if (varValue === "a month ago") {
        return "1 month ago";
    }
    else if (varValue === "a minute ago") {
        return "1 minute ago";
    } 
    else if (varValue === "an hour ago") {
        return "1 hour ago";
    }
    else if (varValue === "in a few seconds") {
        return "a few seconds ago";
    }
     else {
        return varValue;
    }
    
});

Vue.filter("mmddyy", function (value) {
    return moment(value, "MM-dd-yy").format("ll");;
});

/*
 * format - is a moment format string
*/
Vue.filter('formatDate', function(value, format) {
    if (value && value != '') {
        let formatDate = moment(String(value)).format(format)
        if (formatDate == "Invalid date") { // Fix to firefox
            formatDate = moment(String(value), format).format(format)
        }
        return formatDate
    } else {
        return ''
    }
});


// URL to filename
// Extract the filename from Azure file url 
Vue.filter('URL2FileName', function (value) {
    if (!value || value == '') return ''
    value = value.toString()
    if (value.indexOf('https://') !== -1 || value.indexOf('http://') !== -1 || value.indexOf('ftp://') !== -1) {
        // URL
        let split = value.split('/')
        split = split[split.length - 1].split('?')
        return split[0]
    } else {
        return value
    }
});

// URL to Exact filename
Vue.filter('I9URL2FileName', function (value) {
    if (!value || value == '') 
        return ''
    value = value.toString()
    var onblickFileNameConventionLength = 3;//Since all our fileNames are appended with 'obk' at the end
    var timeStampLength = 16;
    if (value.indexOf('https://') !== -1 || value.indexOf('http://') !== -1 || value.indexOf('ftp://') !== -1) {
        var fileUrlArr = value.split('/')
        fileUrlArr = fileUrlArr[fileUrlArr.length - 1].split('?')
        var fileNameWithTimeStampAndExtension = fileUrlArr[0]
        var fileExtension = fileNameWithTimeStampAndExtension.substring(fileNameWithTimeStampAndExtension.lastIndexOf('.'), fileNameWithTimeStampAndExtension.length)
        var fileNameWithTimeStamp = fileNameWithTimeStampAndExtension.substring(0, fileNameWithTimeStampAndExtension.lastIndexOf('.') - onblickFileNameConventionLength)
        var timeStamp = fileNameWithTimeStamp.substring(fileNameWithTimeStamp.length - timeStampLength,fileNameWithTimeStamp.length)
        //var parsedTimeStamp = parseInt(timeStamp)
        var timeStpExcludeUnderScore = timeStamp.slice(1,15);
        var parsedTimeStamp = parseInt(timeStpExcludeUnderScore)
        if(parsedTimeStamp > 0){
           var fileName = fileNameWithTimeStamp.substring(0,fileNameWithTimeStamp.length - timeStampLength)
           value = `${fileName}${fileExtension}`
           return value
        }
        else {
            value = `${fileNameWithTimeStamp}${fileExtension}`
            return value
        }
    } else {
        return value
    }
});

Vue.filter("SpaceAtCapitals", function(value) {
    if(!value) return ""
    value = value.toString();

    return value.replace(/([A-Z])/g, ' $1');

});


/** 
 * This filter is used to get the proper phone number from the given
 * pattern which can be displayed in UI.
 * 
 * Format 1 - <COUNTRY CODE>#<PHONE NUMBER>#<COUNTRY ISO CODE>
 * Ex. 91#999999999#in
 * 
 * Format 2 - <COUNTRY CODE>#<PHONE NUMBER>#<COUNTRY ISO CODE>#<EXTENSION>
 * Ex. 1#2014896324#us#12134
 * 
 * Fallback format
 * Format 3 - <NUMBER WITH COUNTRY CODE>#<EXTENSION>
 * 
 * ELSE - RETURN THE VALUE
 * 
*/
Vue.filter("formatPhoneNumber", function(value) {
    if(!value) return ""
    value = value.toString();

    // Format 1
    let patt1 = /\d+#\d+#[a-zA-Z]{1,3}/g

    // Format 2
    let patt2 = /\d+#\d+#[a-zA-Z]{1,3}#.*/g

    // Format 3
    let patt3 = /\d+#\d+/g

    if(patt1.test(value)) {
        let tempArr = value.split("#");

        return `+${tempArr[0]} ${tempArr[1]}`
    } else if(patt2.test(value)) {
        let tempArr = value.split("#");

        return `+${tempArr[0]} ${tempArr[1]} Ext. ${tempArr[3]}`
    } else if(patt3.test(value)) {
        let tempArr = value.split("#");

        return `+${tempArr[0]} - ${tempArr[1]}`
    } else {
        return value
    }
})


// WEBPACK FOOTER //
// ./src/components/Core/filters.js